import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const QualityPicturesApp = ({

}) => {
    const {
        qualitometer,
        qualitometers,
        citiesIndex,
    } = useSelector(store => ({
        qualitometer: store.QualityReducer.qualitometer,
        qualitometers: store.QualityReducer.qualitometersLight,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[qualitometer.townCode]?.name, [citiesIndex, qualitometer])

    useTitle(() => [{
        title: i18n.quality,
        href: 'quality',
    }, {
        title: getStationTitleWithTownName(qualitometer, townName),
        href: `station/quality/${qualitometer?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/quality/${qualitometer?.id}/picture`,
    }], [qualitometer, townName])

    return (
        <PicturesApp
            stations={qualitometers}
            station={qualitometer}
            stationType='quality'
        />
    )
}

export default QualityPicturesApp